var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75257 7.13991C6.35416 7.59524 5.64583 7.59524 5.24742 7.13991L0.45119 1.6585C-0.114571 1.01192 0.344609 3.24142e-07 1.20377 3.99252e-07L10.7962 1.23785e-06C11.6554 1.31296e-06 12.1146 1.01192 11.5488 1.65851L6.75257 7.13991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldIcon);
export default __webpack_public_path__ + "static/media/fold-icon.11cf1e39dd656f7b3612d655d1a5a570.svg";
export { ForwardRef as ReactComponent };